<template>
  <section class="plan" name="subscriptionPlan">
    <div class="plan__title">{{ $t("paywall.title") }}</div>
    <div class="plan__card">
      <img :src="mediaBaseUrl + 'paywall/card.png'" alt="" />
      <div class="content">
        <div class="title">{{ $t("paywall.plan.card.title") }}</div>
        <div class="price">{{ planPrice }}</div>
        <div class="text">{{ $t("paywall.plan.card.text") }}</div>
      </div>
    </div>
    <button
      v-if="oneClickProvider == 'googlePay' || oneClickProvider == 'applePay'"
      :class="
        oneClickProvider == 'googlePay' ? 'google-pay-btn' : 'apple-pay-btn'
      "
      @click.prevent="showPaymentRequest"
    >
      {{ $t("paywall.buyWith") }}
      <img
        v-if="oneClickProvider == 'googlePay'"
        :src="`${mediaBaseUrl}paywall/google-pay.svg`"
        width="53px"
        height="53px"
      />
      <img
        v-if="oneClickProvider == 'applePay'"
        :src="`${mediaBaseUrl}paywall/apple-pay-logo.png`"
        width="44px"
        height="19px"
      />
    </button>

    <button v-if="!showPaymentForm" @click="scrollTo" class="credit-card-btn">
      {{ $t("paywall.payWithCard") }}
    </button>

    <paywall-payment-form v-if="showPaymentForm" :oneClickProvider="oneClickProvider"></paywall-payment-form>

    <div v-if="!showPaymentForm" class="guarantee">
      <div class="guarantee__title">
        {{ $t("paywall.guarantee.title") }}
      </div>
      <div class="guarantee__text">
        {{ $t("paywall.guarantee.text") }}
      </div>
    </div>
  </section>
</template>

<script>
import { EventBus } from "../../../EventBus";

export default {
  inject: ["mediaBaseUrl"],
  props: {
    oneClickProvider: {
      default: null,
      required: false,
    },
    index: {
      type: Number,
      default: 1,
    },
    cardIndex: {
      type: Number,
      default: 1,
    },
    showPaymentForm: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data () {
    return {
      country: "",
      planPrice: "$1",
    }
  },
  computed: {
    tracker() {
      return this.$root.$children[0].$refs.tracker
    },
  },
  methods: {
    scrollTo() {
      const el = document.documentElement.querySelector(
        '[name="card-payment"]'
      );
      if (el) {
        const offset = el.offsetTop - 70;
        window.scrollTo({
          top: offset,
          behavior: "smooth",
        });
      }
      this.tracker.report(`User_click_subscription_get_card_plan${this.$props.cardIndex}`)
    },
    showPaymentRequest() {
      if (this.$props.oneClickProvider === 'applePay') {
        this.tracker.report(`User_click_subscription_apple_pay${this.$props.index}`)
      } else if (this.$props.oneClickProvider === 'googlePay') {
        this.tracker.report(`User_click_subscription_google_pay${this.$props.index}`)
      }
      EventBus.$emit("click-start-now", false, this.$props.index);
    },
  },

  mounted() {
    fetch('https://ipapi.co/json/')
      .then( res => res.json())
      .then(response => {
        this.country = response.country
        console.log("Country: ", response.country);
      })
      .catch((data, status) => {
        console.log('Request failed');
      })
  },

  watch: {
    country(value) {
      switch (value) {
        case "KZ":
          this.planPrice = "499 ₸"
          break;
        case "UA":
          this.planPrice = "49 ₴"
          break;
        default:
          this.planPrice = "$1"
          break;
      }
    },
  },
};
</script>

<style scoped lang="sass">
$lg: 700px

.plan
  width: 100%
  padding: 24px 16px 39px !important

  &__title
    font-size: 24px
    font-weight: 700
    line-height: 33.6px
    text-align: center
    color: #1B2A3F
    margin-bottom: 28px

  &__card
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    padding: 14px 39px 17px
    margin-bottom: 21px
    position: relative

    img
      position: absolute
      width: calc(100% + 20px)
      height: auto
      object-fit: cover
      z-index: 1
      max-height: 195px
      max-width: 342px

    .content
      width: 100%
      height: 100%
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      z-index: 2

      @media screen and (min-width: $lg)
        max-width: 264px

      .title
        width: 100%
        font-size: 20px
        font-weight: 510
        line-height: 28px
        text-align: center
        color: #1B2A3F
        padding-bottom: 11px
        border-bottom: 1px solid #1B2A3F

      .price
        font-size: 64px
        font-weight: 510
        line-height: 89.6px
        text-align: center
        color: #1B2A3F

      .text
        font-size: 14px
        font-weight: 510
        line-height: 19.6px
        text-align: center
        color: #798495
        max-width: 120px

  .apple-pay-btn
    width: 100%
    padding: 14px
    border-radius: 4px
    background: #1B2A3F
    color: #FFFFFF
    display: flex
    align-items: center
    justify-content: center
    font-size: 18px
    font-weight: 500
    line-height: 27px
    text-align: center
    margin-bottom: 16px
    gap: 6px
    cursor: pointer
    border: none

    @media screen and (min-width: $lg)
      max-width: 343px

  .google-pay-btn
    width: 100%
    border-radius: 4px
    background: #1B2A3F
    color: #FFFFFF
    display: flex
    align-items: center
    justify-content: center
    font-size: 18px
    font-weight: 500
    line-height: 27px
    text-align: center
    margin-bottom: 16px
    padding: 1px 14px
    gap: 8px
    cursor: pointer

    @media screen and (min-width: $lg)
      max-width: 343px

  .credit-card-btn
    width: 100%
    padding: 14px
    gap: 0px
    border-radius: 4px
    border: 2px solid #1B2A3F
    color: #1B2A3F
    display: flex
    align-items: center
    justify-content: center
    font-size: 18px
    font-weight: 500
    line-height: 27px
    text-align: center
    margin-bottom: 28px
    cursor: pointer

    @media screen and (min-width: $lg)
      max-width: 343px

  .guarantee
    max-width: 880px

    &__title
      font-size: 16px
      font-weight: 600
      line-height: 24px
      text-align: center
      color: #07182D
      margin-bottom: 12px
      text-decoration: underline

    &__text
      font-size: 13px
      font-weight: 400
      line-height: 19.5px
      text-align: center
      color: #999999
</style>
